<template>
  <div class="container mx-auto my-8 bg-white py-2 rounded-lg">
    <div v-if="loading" class="flex justify-center py-8">
      <div
        class="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-primaryDarkBg"
      ></div>
    </div>
    <div v-else class="overflow-x-auto text-grayDark">
      <div v-if="dumpdata.length === 0" class="text-center py-16">
        <p
          class="mx-auto bg-primaryLight px-2 py-24 border border-grayLight rounded-[16px]"
        >
          Dump Data not found.
        </p>
      </div>
      <div v-else>
        <table class="min-w-full divide-y">
          <thead class="text-[12px]">
            <tr class="bg-[#F9FAFB]">
              <th scope="col" class="px-6 py-3 text-left">ID</th>
              <th scope="col" class="py-3 text-left tracking-wider">
                Start Date and Time
              </th>
              <th scope="col" class="py-3 text-left tracking-wider">
                End Date and Time
              </th>
              <th scope="col" class="py-3 text-left tracking-wider">
                Error Note/Reason
              </th>
              <th scope="col" class="py-3 text-left tracking-wider">Percent</th>
            </tr>
          </thead>
          <tbody class="bg-white divide-y divide-gray-200">
            <tr
              v-for="data in dumpdata"
              :key="data.id"
              class="mb-2 text-[13px]"
              @click="openSideMenu(data)"
            >
              <td class="py-4 whitespace-nowrap">
                {{ data.id }}
              </td>

              <td class="py-4 whitespace-nowrap">
                {{ data.startTime }}
              </td>
              <td class="py-4 whitespace-nowrap">{{ data.endTime }}</td>
              <td class="py-4 whitespace-nowrap">
                {{ data.message }} : {{ data.note }}
              </td>
              <td class="py-4 whitespace-nowrap">{{ data.percent }}</td>
            </tr>
          </tbody>
        </table>

        <PaginationComponent
          :currentPage="currentPage"
          :totalPages="totalPages"
          @changePage="handlePageChange"
        />
      </div>
    </div>

    <div
      v-if="isSideMenuOpen"
      class="fixed inset-0 bg-black bg-opacity-40 backdrop-blur-sm z-40"
      @click="closeSideMenu"
    ></div>

    <div
      v-if="isSideMenuOpen"
      class="fixed top-0 right-0 w-[543px] h-full bg-white shadow-lg z-50 transform transition-transform duration-300 text-[14px] text-bodyText"
    >
      <div class="px-5 py-4 border border-b-[1px] space-y-4">
        <div class="py-4 flex justify-between items-center border-grayLight">
          <h3 class="text-lg font-medium">
            Activity:id[{{ selectedDumpData?.id }}]
          </h3>
          <button @click="closeSideMenu" class="hover:text-primaryDark">
            <img
              src="@/assets/dashboard/iconoir_cancel.svg"
              alt="Close"
              class="w-4 h-4"
            />
          </button>
        </div>
      </div>

      <div class="px-5 py-8 border border-b-[1px] space-y-4">
        <div class="flex items-center gap-[28px]">
          <label class="block text-[14px] font-medium">Start Time</label>
          <input
            v-model="selectedDumpData.startTime"
            class="mt-1 block w-[399px] h-[44px] px-3 py-2 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm bg-[#F6F8F9]"
            required
          />
        </div>
        <div class="flex items-center gap-[19px]">
          <label class="block text-[14px] font-medium">End Time</label>
          <input
            v-model="selectedDumpData.endTime"
            class="mt-1 block w-[399px] h-[44px] px-3 py-2 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm bg-[#F6F8F9]"
            required
          />
        </div>
        <div class="flex items-center gap-[43px]">
          <label class="block text-[14px] font-medium">Error note/resaon</label>
          <input
            v-model="selectedDumpData.message"
            type="text"
            class="mt-1 block w-[401px] h-[64px] px-3 py-2 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm bg-[#F6F8F9]"
            required
          />
        </div>
        <div class="flex items-center gap-[19px]">
          <label class="block text-[14px] font-medium">Study Hours</label>
          <input
            v-model="selectedDumpData.studyHours"
            type="text"
            class="mt-1 block w-[399px] h-[44px] px-3 py-2 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm bg-[#F6F8F9]"
            required
          />
        </div>
        <div class="flex items-center gap-[19px]">
          <label class="block text-[14px] font-medium">App Events</label>
          <div
            v-for="event in selectedDumpData.appEvents"
            :key="event.time"
            class="mt-1 block w-[399px] h-[44px] px-3 py-2 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm bg-[#F6F8F9] flex flex-col justify-center"
          >
            <span class="text-sm font-medium">app name: {{ event.name }}</span>
            <span class="text-xs text-gray-500"
              >description: {{ event.description }}</span
            >
            <span class="text-xs text-gray-500">url: {{ event.url }}</span>
            <span class="text-xs text-gray-500">time: {{ event.time }}</span>
          </div>
        </div>
      </div>

      <!-- <div class="px-5 py-8 space-y-4">
        <label class="block text-[14px] font-medium">Feedback received</label>
        <textarea
          v-model="selectedDumpData.description"
          placeholder="Enter task description"
          class="mt-1 block w-full h-[152px] px-3 py-2 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm bg-[#F6F8F9]"
          required
        ></textarea>
      </div> -->
    </div>
  </div>
</template>
  
  <script>
import apiClient from "@/axios";
import PaginationComponent from "../PaginationComponent.vue";

export default {
  name: "ReportsTable",
  components: {
    PaginationComponent,
  },
  data() {
    return {
      isSideMenuOpen: false,
      dumpdata: [],
      projectId: this.$route.params.projectId,
      currentPage: 1,
      totalPages: 1,
      pageSize: 10,
      loading: true,
    };
  },
  computed: {
    isAdmin() {
      return this.$store.getters.isAdmin;
    },
  },
  methods: {
    openSideMenu(dumpData) {
      this.selectedDumpData = dumpData; // Set the selected task
      this.isSideMenuOpen = true; // Open the side menu
    },
    closeSideMenu() {
      this.isSideMenuOpen = false; // Close the side menu
      this.selectedDumpData = null; // Clear the selected task
    },
    convertUnixTimeToDateTime(timestamp) {
      const date = new Date(timestamp * 1000);
      return date.toLocaleString("en-US", {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
        hour12: false,
      });
    },
    formatTimeDifference(timestamp1, timestamp2) {
      const diff = Math.abs(timestamp2 - timestamp1) * 1000;

      const days = Math.floor(diff / (1000 * 60 * 60 * 24));
      const hours = Math.floor(
        (diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
      );
      const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((diff % (1000 * 60)) / 1000);

      const parts = [];
      if (days > 0) parts.push(`${days} day${days !== 1 ? "s" : ""}`);
      if (hours > 0) parts.push(`${hours} hour${hours !== 1 ? "s" : ""}`);
      if (minutes > 0)
        parts.push(`${minutes} minute${minutes !== 1 ? "s" : ""}`);
      if (seconds > 0)
        parts.push(`${seconds} second${seconds !== 1 ? "s" : ""}`);

      return parts.join(", ") || "0 seconds";
    },
    async fetchDumpData() {
      this.loading = true;
      try {
        const response = await apiClient.get(`/web/dumpdata`, {
          params: {
            page: this.currentPage,
            page_size: this.pageSize,
          },
        });

        this.dumpdata =
          response.data.data.map((data) => {
            return {
              id: data.id,
              startTime: this.convertUnixTimeToDateTime(data.data.start_time),
              endTime: this.convertUnixTimeToDateTime(data.data.end_time),
              message: data.message,
              note: data.data.note,
              percent: data.data.percent,
              studyHours: this.formatTimeDifference(
                data.data.end_time,
                data.data.start_time
              ),
              appEvents: data.data.app_events || [],
            };
          }) || [];
        this.totalPages = response.data.meta.total_pages;
        this.loading = false;
      } catch (error) {
        console.error("Error fetching dump data:", error);
        this.loading = false;
      }
    },

    handlePageChange(newPage) {
      if (newPage > 0 && newPage <= this.totalPages) {
        this.currentPage = newPage;
        this.fetchDumpData();
      }
    },
  },
  created() {
    this.fetchDumpData(); // Fetch the first page on mount
  },
};
</script>
  